import { motion } from 'framer-motion';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import loadingAnimationData from '@/components/common/svg/assets/loader_v2.json';
import UIConfig from '@/UIConfig.ts';
import LottieAnimation from '@/animations/LottieAnimation.tsx';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { giftActionButtonStyle } from '@/components/Messanger/Chat/ClaimGiftPopup/components/styles.ts';

interface AcceptGiftProps {
  contactId: string;
  onGiftAccepted: () => void;
}

const AcceptGift: FC<AcceptGiftProps> = ({ contactId, onGiftAccepted }) => {
  const [isAccepting, setIsAccepting] = useState(false);

  const { acceptGift } = useDialogsStore();

  const { t } = useTranslation();

  const handleAcceptGift = async () => {
    setIsAccepting(true);
    await acceptGift(contactId);
    setIsAccepting(false);
    onGiftAccepted();
  };

  return (
    <motion.div
      whileTap={{ scale: 0.9 }}
      style={{
        ...giftActionButtonStyle,
        background: UIConfig.Colors.BackgroundDark,
        color: 'white'
      }}
      onClick={handleAcceptGift}
    >
      {isAccepting ? (
        <LottieAnimation
          width={40}
          height={40}
          animationData={loadingAnimationData}
          color="#fff"
          shouldAnimate={true}
          loop={true}
        />
      ) : (
        <>
          <span style={{ fontSize: '17px' }}>
            {t('chats.accept_gift_button')}
          </span>
        </>
      )}
    </motion.div>
  );
};

export default AcceptGift;
